module.exports = __webpack_public_path__ + "static/media/50_A.b95e6268.png";